import React from 'react'
import { useIntl } from 'react-intl'
import { Icons, CustomLinkComponent } from 'msp-components'

export const sealIconsMapper = (seals?: string[]) => {
  const sealSvgs = {
    bio: <Icons iconName='Bio' width='40px' />,
    fairTrade: <Icons iconName='FairTrade' width='40px' />,
    ras: <Icons iconName='Rainforest' width='40px' />,
    rasApple: <Icons iconName='RainforestApple' width='60px' />,
    ras62Apple: <Icons iconName='RainforestApple62' width='60px' />,
    ras70Apple: <Icons iconName='RainforestApple70' width='60px' />,
    ras73Apple: <Icons iconName='RainforestApple73' width='60px' />,
    ras76Apple: <Icons iconName='RainforestApple76' width='60px' />,
    ras80Apple: <Icons iconName='RainforestApple80' width='60px' />,
    rasCamomile: <Icons iconName='RainforestCamomile' width='60px' />,
    rasFruit: <Icons iconName='RainforestFruit' width='60px' />,
    ras70Fruit: <Icons iconName='RainforestFruit70' width='60px' />,
    rasRooibos: <Icons iconName='RainforestRooibos' width='60px' />,
    rasTea: <Icons iconName='RainforestTea' width='60px' />
  }

  if (!seals || seals.length === 0) return []
  return seals.map((seal) => sealSvgs[seal])
}

export const benefitIconsMapper = (benefits?: string[]) => {
  const { formatMessage } = useIntl()

  const benefitIcons = {
    allergenFree: {
      icon: <Icons iconName='AllergyFree' width='40px' height='40px' />,
      label: formatMessage({
        id: 'msp.product.benefits.allergy_free',
        defaultMessage: 'Allergy Free'
      })
    },
    sugarFree: {
      icon: <Icons iconName='SugarFree' width='40px' height='40px' />,
      label: formatMessage({
        id: 'msp.product.benefits.sugar_free',
        defaultMessage: 'Sugar Free'
      })
    },
    bio: {
      icon: <Icons iconName='Organic' width='40px' height='40px' />,
      label: formatMessage({
        id: 'msp.product.benefits.certified_organic',
        defaultMessage: 'Certified Organic'
      })
    },
    glutenFree: {
      icon: <Icons iconName='GlutenFree' width='40px' height='40px' />,
      label: formatMessage({
        id: 'msp.product.benefits.gluten_free',
        defaultMessage: 'Gluten Free'
      })
    },
    caffeineFree: {
      icon: <Icons iconName='CaffeineFree' width='40px' height='40px' />,
      label: formatMessage({
        id: 'msp.product.benefits.caffeine_free',
        defaultMessage: 'Caffeine Free'
      })
    }
  }

  if (!benefits || benefits.length === 0) return []
  return benefits.map((benefit) => benefitIcons[benefit])
}

export const getProductCategoryTag = (product: any, style: string) => {
  return product?.c_primary_category_name ? (
    <CustomLinkComponent
      className={style}
      inline
      href={product?.c_classCategoryID && `/shop/${product?.primaryCategoryId}`}
    >
      {product?.c_primary_category_name}
    </CustomLinkComponent>
  ) : null
}
